// extracted by mini-css-extract-plugin
export default {"meta":"meta___l66N2","id":"id___VSyW7"};